import React, {Component} from 'react';
import './AddNewProjectModal.css';
import Inputs from '../../../shared/FormComponents/Inputs';
import _ from 'lodash';

class AddNewProjectModal extends Component {

  constructor(props) {
    super(props);
    this.defaultParams = {};
    this.state = {
        projectadded: false,
        addProjectData: false,
        formValid: false,
        createProject: {
            name : '',
        },
        inputStates: {
            name: false,
        }
    };
  }

  closeModal = () => {
    this.props.openModal();
    const state = _.extend({}, this.state);
    state.inputStates.name = false;
    state.createProject.name = '';
  }

onDataChange = (key, value, valid) => {
    const state = _.extend({}, this.state);
    state.inputStates[key] = valid;
    state.createProject[key] = value;
    this.setState(state, () => this.validateForm());
};

validateForm = () => {
    let validationStates = _.extend({}, this.state.inputStates);
    let key = Object.values(validationStates).indexOf(false) !== -1;
    let state = !key;
    this.setState({ formValid: state });
}
createProject = () => {
    this.props.addedNewProjectState();
    this.setState({ projectadded : false });
    let data = {
        projectName: this.state.createProject.name
    }
    localStorage.removeItem("openedTool");
    this.props.createProject(data)
}

componentWillReceiveProps(nextProps){

    if(nextProps.createdProjectData.statusCode === 200 && !this.state.projectadded ){
        this.closeModal();
        this.setState({ projectadded : true });
    }
}

elementInfiniteLoad() {
    return (
        <div className='col-sm-12'>
            <div className='spinner3'>
            <div className='rect1'/>
            <div className='rect2'/>
            <div className='rect3'/>
            <div className='rect4'/>
            <div className='rect5'/>
            </div>
        </div>
    );
}

render() {
    return (
        <div>
            <div className='opacity-overlay ' style={{'display': 'block'}}>
                <div className="container">
                    <div className="popup-wrapper">
                        <div className="col-xs-12 col-sm-4 popup-content">
                            { !this.props.createdProjectFetching &&
                                <div>
                                    <div className='modal-header'>
                                        <h5>Create New Project</h5>
                                    </div>
                                    <div className='modal-body'>
                                    {/* <form> */}
                                        <div className="form-group">
                                            <Inputs
                                                type="name"
                                                className="form-control"
                                                value={this.state.createProject.name}
                                                required={ true }
                                                placeholder='Project Name'
                                                onChange={ (value, valid) => this.onDataChange('name', value, valid)} 
                                                onKeyPress={this.createProject}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => this.createProject()}
                                            disabled={!this.state.formValid}
                                            className="btn btn-success">
                                            Create 
                                        </button>
                                        <div 
                                            onClick={() => this.props.openModal()} 
                                            className="btn btn-cancel">
                                                Close
                                        </div>
                                    {/* </form> */}

                                    
                                </div>
                                </div>
                            }
                            { this.props.createdProjectFetching &&
                                <div>
                                    {this.elementInfiniteLoad()}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}

export default (AddNewProjectModal);



// WEBPACK FOOTER //
// ./src/components/Toolkit/AddNewProjectModal/AddNewProjectModal.jsx